import {
  lesson19Assignment,
  lesson19Assignment2,
  lesson19Assignment3,
  lesson19Activity3
} from './assignments'
import { createChessboard } from '../../utils/index';

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 2,
    video: {
      src: 'img/videos/lesson_19/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 2,
    audio: { src: 'img/audio/lesson_19/1.mp3', start: true, controls: false },
    directions: {
      timeout: 1000,
      data: '<b>DIRECTIONS:</b> <br/> This activity is to see how many captures you can make on g4. Just focus on that one square.You play white.'
    },
    chessboard: {
      board: lesson19Assignment({
        position: '3r1br1/3q3k/1p2bn1n/pPp1p1pp/P1PpPp2/3P1P1P/1R1KBNPN/2BQ1R2',
        studentMoves: ['f3', 'h3', 'f2', 'h2', 'e2', 'd1'],
        fromMoves: ['g5', 'h5', 'h6', 'f6', 'e6', 'g8', 'd7'],
        toMove: 'g4',
        showIndicators: { allSides: true },
        wrongMessage: 'Oops...! Try again.',
        next: 2
      }),
      positionFen: '3r1br1/3q3k/1p2bn1n/pPp1p1pp/P1PpPp2/3P1P1P/1R1KBNPN/2BQ1R2 w - - 0 1',
    }
  },
  {
    id: 2,
    previous: 0,
    next: 4,
    video: {
      src: 'img/videos/lesson_19/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 3
    }
  },
  {
    id: 3,
    previous: 2,
    next: 4,
    audio: { src: 'img/audio/lesson_19/2.mp3', start: true, controls: false },
    directions: {
      timeout: 1000,
      data: '<b>DIRECTIONS:</b> <br/>Both White Rooks are attacking black pieces. Which one should White capture first? <br/> You play White, your move.'
    },
    chessboard: {
      board: lesson19Assignment2({
        position: '1n2r1k1/3b1pp1/7p/8/3P3P/6P1/5P2/1R2R1K1',
        resultFen: '4R1k1/5p2/6pp/8/3P3P/6P1/5P2/6K1',
        next: 4,
        failedMove: {
          studentMove: {
            from: ['b1'],
            to: ['b8']
          },
          computerMove: {
            from: ['e8'],
            to: ['b8']
          },
          captureStudentMove: {
            capturedPiece: ['bN'],
            capturingPiece:['wR']
          },
          captureComputerMove: {
            capturedPiece: ['wR'],
            capturingPiece:['bR']
          }
        },
        successMove: {
          studentMove: {
            from: ['e1', 'b1', 'b8'],
            to: ['e8', 'b8', 'e8']
          },
          computerMove: {
            from: ['d7','g7'],
            to: ['e8','g6']
          },
          captureStudentMove: {
            capturedPiece: ['bR', 'bN', 'bB'],
            capturingPiece:['wR', 'wR', 'wR']
          },
          captureComputerMove: {
            capturedPiece: ['wR'],
            capturingPiece:['bB']
          }
        },
        showIndicators: { allSides: true },
      }),
      positionFen: '1n2r1k1/3b1pp1/7p/8/3P3P/6P1/5P2/1R2R1K1 w - - 0 1',
    }
  },
  {
    id: 4,
    previous: 2,
    next: 6,
    video: {
      src: 'img/videos/lesson_19/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 5
    }
  },
  {
    id: 5,
    previous: 4,
    next: 6,
    audio: { src: 'img/audio/lesson_19/3.mp3', start: true, controls: false },
    directions: {
      timeout: 1000,
      data: '<b>DIRECTIONS:</b> <br/> You are going to play the next two moves for White. Look at all possible moves and captures.'
    },
    chessboard: {
      board: lesson19Assignment3({
        position: '2n1r1k1/5pp1/B6p/4n3/8/6BP/5PP1/R5K1',
        result: ['2r3k1/5pp1/7p/4B3/8/7P/5PP1/R5K1', '2B3k1/5pp1/7p/4r3/8/7P/5PP1/R5K1'],
        next: 6,
        bishop1Moves: {
          studentMove: {
            from: ['a6', 'g3'],
            to: ['c8', 'e5']
          },
          computerMove: {
            from: ['e8'],
            to: ['c8']
          },
          captureStudentMove: {
            capturedPiece: ['bN', 'bN'],
            capturingPiece:['wB', 'wB']
          },
          captureComputerMove: {
            capturedPiece: ['wB'],
            capturingPiece:['bR']
          }
        },
        bishop2Moves: {
          studentMove: {
            from: ['g3', 'a6'],
            to: ['e5', 'c8']
          },
          computerMove: {
            from: ['e8'],
            to: ['e5']
          },
          captureStudentMove :{
            capturedPiece: ['bN', 'bN'],
            capturingPiece:['wB', 'wB']
          },
          captureComputerMove: {
            capturedPiece: ['wB'],
            capturingPiece:['bR']
          }
        },
        showIndicators: { allSides: true },
        wrongMessage: 'Use a Bishop to make a capture',
      }),
      positionFen: '2n1r1k1/5pp1/B6p/4n3/8/6BP/5PP1/R5K1 w - - 0 1',
    }
  },
  {
    id: 6,
    previous: 4,
    next: 7,
    video: {
      src: 'img/videos/lesson_19/4.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 7
    }
  },
  {
    id: 7,
    previous: 6,
    next: 8,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: 'Find a successful double attack for White:',
      answer: [
        'c5',
        'Bxb6',
        'Be2',
        'Qd1'
      ],
      chessboard: {
        board: lesson19Activity3({
          showIndicators: true,
          starSquares: ['.square-d6', '.square-h5'],
          position: 'r2qk2r/p2p1ppp/1pbbp3/7n/2P1P3/P1N1B3/1PQ2PPP/R3KB1R',
        }),
        hint: true
      },
      rightAnswer: 'Qd1',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'sm'
    }
  },
  {
    id: 8,
    previous: 6,
    next: 9,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: 'How many different checks, good and bad, <br/>does Black have on this move?',
      answer: [
        '4',
        '6',
        '8',
        '10'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '4Q3/2K5/2B5/3P2P1/1q1nP2P/4p3/1b2bRp1/1k6',
        }),
        hint: true
      },
      rightAnswer: '8',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'sm'
    }
  },
  {
    id: 9,
    previous: 6,
    next: 10,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: 'Which capture is best for White?',
      answer: [
        'Qd1xg4',
        'Bg5xf6',
        'b4xa5',
        'b4xc5'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: 'r2q2k1/pp3ppp/2p2n2/3p2B1/3P2b1/2P5/PP3PPP/R2Q1NK1',
        }),
        hint: true
      },
      rightAnswer: 'Bg5xf6',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'sm'
    }
  },
  {
    id: 10,
    previous: 6,
    next: 11,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: 'Which two-move plan will lead to <br/> checkmating the White King?',
      answer: [
        'Re8xe3 and Re3-e1+',
        'Re8-d8 and Rd7-d1+',
        'Rd7-d1+ and Re8-d8',
        'Rd7-h7 and Re8-h7'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '1k2r3/3r4/8/2P5/1P4p1/P3PpPp/5P1P/R6K',
        }),
        hint: true
      },
      rightAnswer: 'Re8-d8 and Rd7-d1+',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 11,
    previous: 6,
    next: 12,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'This game will be a stalemate if the Black <br/> King can get to h8. What move will stop him?',
      answer: [
        'h6-h7',
        'Bd3-c4+',
        'Bd3-g6+',
        'Bd3-h7'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '8/5k2/7P/8/8/3B2K1/8/8',
        }),
        hint: true
      },
      rightAnswer: 'Bd3-h7',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'sm'
    }
  },
  {
    id: 12,
    previous: 6,
    next: 13,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'Which move will force the Black <br/> King into the corner?',
      answer: [
        'Rf2-f8+',
        'Re1-g1+',
        'Rf2-g2+',
        'Bd3-h7+'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '6k1/8/pq2p3/1p1n4/8/P2B4/1P3R2/K3R3',
        }),
        hint: true
      },
      rightAnswer: 'Re1-g1+',
      validateAnswer: { rightAnswer: '1', userAnswer: -1 },
      styleClass: 'sm'
    }
  },
  {
    id: 13,
    previous: 6,
    next: 14,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'Which White move will create checkmate?',
      answer: [
        'Rg1-h1#',
        'Rg1-g8#',
        'Rf2-h2#',
        'Rf2-f8#'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '7k/8/pq2p3/1pb5/8/P2B4/1P3R2/K5R1',
        }),
        hint: true
      },
      rightAnswer: 'Rf2-h2#',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'sm'
    }
  },
  {
    id: 14,
    previous: 6,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'How can Black successfully get a Queen? <br/> (she isn’t captured right away)',
      answer: [
        'Move the f-pawn twice then move the b-pawn twice.',
        'Move each pawn once, then move each one more time.',
        'Move the Black King to a3',
        'Play the Black King to h8'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '5k2/8/7K/8/8/1p1B1p2/8/8',
        }),
        hint: true
      },
      rightAnswer: 'Move each pawn once, then move each one <br/> more time.',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 15,
    previous: 6,
    next: 16,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 8,
      question: 'What is most important to look at when planning?',
      answer: [
        'Blocking moves',
        'Checks and captures',
        'Your second move no matter what',
        'Castling'
      ],
      rightAnswer: 'Checks and captures',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'sm'
    }
  },
  {
    id: 16,
    previous: 6,
    next: 17,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 9,
      question: 'What is the second thing to look at when planning?',
      answer: [
        'Your opponent’s next move',
        'Your second move no matter what',
        'How many pieces you’ve already captured',
        'Castling'
      ],
      rightAnswer: 'Your opponent’s next move',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 17,
    previous: 6,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      result: true,
      nextLesson: 'Lesson Twenty',
      styleClass: 'xl'
    }
  }
]

let assets = [
  '/img/background_14.png',
  '/img/background_15.png',
  '/img/background_16.png',
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;



// WEBPACK FOOTER //
// ./src/lessons/lesson_19/index.js